export const createContract = {
  // ── Page / Breadcrumb ──────────────────────────────────────────────────────
  CC_PAGE_TITLE:              'Create Customer Agreement',
  CC_CONTRACT_NO_LABEL:       'Contract No.',
  CC_HEADER_EYEBROW:          'New Document',
  CC_PAGE_SUBTITLE:           'On this page, you can create a customer agreement by adding the parties, assignment scope, compensation, and signatures — all in one place.',



  // ── Stepper ────────────────────────────────────────────────────────────────
  CC_STEP_COMPANY_LOGO:       'Company Logo',
  CC_STEP_PARTIES_INFO:       'Parties Information',
  CC_STEP_ASSIGNMENT:                 'Assignment',
  CC_STEP_COMPENSATION:              'Compensation',
  CC_STEP_ASSIGNMENT_COMPENSATION:   'Assignment & Compensation',
  CC_STEP_LEGAL_SIGNATURES:          'Legal & Signatures',
  CC_STEP_COMPANY_LOGO_SUB:            'Brand the document',
  CC_STEP_PARTIES_INFO_SUB:            'Who is involved',
  CC_STEP_ASSIGNMENT_COMPENSATION_SUB: 'Scope & payment',
  CC_STEP_LEGAL_SIGNATURES_SUB:        'Review & sign',

  // ── Step 0 — Company Logo ──────────────────────────────────────────────────
  CC_LOGO_CARD_TITLE:         'Company Logo',
  CC_LOGO_CARD_SUBTITLE:      'Upload your company logo to personalise the customer ggreement document.',
  CC_LOGO_NO_LOGO:            'No company logo uploaded',
  CC_LOGO_CHANGE_IN_SETTINGS: 'Change Logo in Profile Settings',
  CC_LOGO_SETTINGS_NOTE:      'Your company logo is configured in your profile settings and will appear on all documents.',
  CC_LOGO_PROFILE_SUMMARY:    'Your Profile',
  CC_INVOZIO_INFO_TITLE:      'Invozio Information',
  CC_INVOZIO_INFO_COMPANY:    'Invozio LV SIA',
  CC_INVOZIO_INFO_REG:        '502085-4062',
  CC_INVOZIO_INFO_REF:        '(Referred to below as "Invozio")',
  CC_PREFERRED_LANGUAGE_LABEL: 'Preferred language',
  CC_PREFERRED_LANGUAGE_HINT:  'The language this contract (and its document/email) will be created in. Defaults to your platform language the first time, then remembers your last choice.',

  // ── Step 1 — Parties Information ───────────────────────────────────────────
  CC_PARTIES_CUSTOMER_INFO:           'Customer Information',
  CC_PARTIES_ADD_CUSTOMER:            'Add New Customer',
  CC_PARTIES_SELECT_LABEL:            'Select existing customer:',
  CC_PARTIES_SELECT_PLACEHOLDER:      'Select customer',
  CC_PARTIES_REMOVE_CUSTOMER:         'Remove',
  CC_PARTIES_CUSTOMER_NAME_LABEL:     'Customer Name:',
  CC_PARTIES_CUSTOMER_NAME_HINT:      'Enter customer name',
  CC_PARTIES_ORG_NUMBER_LABEL:        'Organisation Number:',
  CC_PARTIES_ORG_NUMBER_HINT:         '12345678-9900',
  CC_PARTIES_BILLING_ADDRESS_LABEL:   "Customer's billing address:",
  CC_PARTIES_BILLING_ADDRESS_HINT:    'Enter billing address',
  CC_PARTIES_OFFERED_SERVICES_LABEL:  'Offered Services',
  CC_PARTIES_OFFERED_SERVICES_HINT:   'e.g. Consulting services',
  CC_PARTIES_ASSIGN_PERIOD_LABEL:     'Assignment Period',
  CC_PARTIES_ASSIGN_PERIOD_HINT:      'e.g. Ongoing',
  CC_PARTIES_WORK_DESC_LABEL:         'Specify work and what is included:',
  CC_PARTIES_WORK_DESC_HINT:          'Describe the scope of work',
  CC_PARTIES_SPECIAL_TERMS_LABEL:     'Special terms:',
  CC_PARTIES_SPECIAL_TERMS_HINT:      'Enter any special terms or conditions...',

  // ── Step 2 — Assignment ────────────────────────────────────────────────────
  CC_ASSIGN_PERIOD_TITLE:       'Agreement Period',
  CC_ASSIGN_START_DATE:         'Start date',
  CC_ASSIGN_END_DATE:           'End date',
  CC_DATE_PLACEHOLDER:          'yyyy/mm/dd',
  CC_ASSIGN_NO_END_DATE:        'No end date',
  CC_ASSIGN_NO_END_DATE_INFO:   'Check this if the assignment continues indefinitely with no fixed end date.',
  CC_ASSIGN_NOTICE_CHECKBOX:    'Notice period',
  CC_ASSIGN_NOTICE_INFO:        'Check this if either party must give advance notice before ending the assignment early.',
  CC_ASSIGN_NOTICE_LABEL:       'Notice period',
  CC_ASSIGN_NOTICE_1M:          '1 month',
  CC_ASSIGN_NOTICE_2M:          '2 months',
  CC_ASSIGN_NOTICE_3M:          '3 months',
  CC_ASSIGN_NOTICE_6M:          '6 months',
  CC_ASSIGN_NOTICE_HINT:        'Customer must be notified this long before the agreement end date.',
  CC_ASSIGN_DESC_TITLE:         'Assignment Description',
  CC_ASSIGN_DESC_LABEL:         'Describe the services and deliverables that will be provided under this agreement.',
  CC_ASSIGN_DESC_HINT:          'Enter a detailed description of the assignment...',
  CC_PARTIES_NO_CUSTOMERS:      'Customer not found',

  // ── Step 3 — Compensation ──────────────────────────────────────────────────
  CC_COMP_TITLE:                'Compensation Details',
  CC_COMP_TYPE_LABEL:           'Compensation type',
  CC_COMP_TYPE_PLACEHOLDER:     'Select type',
  CC_COMP_TYPE_PER_HOUR:        'Payment per hour',
  CC_COMP_TYPE_PER_DAY:         'Payment per day',
  CC_COMP_TYPE_PER_WEEK:        'Payment per week',
  CC_COMP_TYPE_PER_MONTH:       'Payment per month',
  CC_COMP_TYPE_AS_AGREED:       'Fixed price',
  CC_COMP_TYPE_PER_UNIT:        'Payment per unit',
  CC_COMP_UNIT_LABEL:           'Number of units',
  CC_COMP_UNIT_HINT:            'e.g. 10',
  CC_COMP_CURRENCY_LABEL:       'Currency',
  CC_COMP_AMOUNT_LABEL:         'Amount',
  CC_COMP_AMOUNT_HINT:          'Enter amount',
  CC_COMP_INVOICE_NOTE:         'Invoicing for work performed will be issued on a monthly basis. A 30-day payment term applies. A reminder fee of 60 SEK and a collection fee of 180 SEK are currently applicable, or the amounts otherwise stipulated by law. Late payment interest will also apply.',

  // ── Step 4 — Legal & Signatures ───────────────────────────────────────────
  CC_LEGAL_CARD_TITLE:               'Legal Terms & Conditions',
  CC_LEGAL_TAXES_HEADING:            'Taxes and Fees',
  CC_LEGAL_TAXES_BODY:               'The compensation is exclusive of VAT. Invozio is solely responsible for payroll administration, tax withholdings, social security contributions, and other statutory obligations related to the Service Provider. Upon reasonable request, Invozio shall provide evidence of compliance.',
  CC_LEGAL_INSURANCE_HEADING:        'Insurance',
  CC_LEGAL_INSURANCE_BODY:           'Invozio maintains insurance coverage in accordance with its insurance policies in force from time to time. Coverage is subject to the terms, conditions, exclusions and limitations of the applicable insurance policies.',
  CC_LEGAL_CONFIDENTIALITY_HEADING:  'Confidentiality',
  CC_LEGAL_CONFIDENTIALITY_BODY:     'The freelancer and Invozio undertake not to disclose confidential information obtained through the assignment except as required by law or for the administration of the assignment.',
  CC_LEGAL_ROLE_HEADING:             'Service Provider Responsibility',
  CC_LEGAL_ROLE_BODY:                "The Services are performed by an independent Service Provider engaged through Invozio. The Service Provider is solely responsible for the performance, quality, qualifications, and delivery of the Services. Invozio's role is limited to administrative, invoicing, payroll, insurance, and compliance-related services.",
  CC_LEGAL_LIMITATION_HEADING:       'Limitation of Liability',
  CC_LEGAL_LIMITATION_BODY:          "Invozio's total liability under this Agreement shall not exceed the fees paid by the Customer to Invozio during the twelve (12) months preceding the claim.",
  CC_LEGAL_ACK_HEADING:              'Client Acknowledgement',
  CC_LEGAL_ACK_BODY:                 'The Client acknowledges that all services are provided directly by the Freelancer who bears sole and exclusive responsibility for scope, quality, performance, and delivery of those services.',
  CC_LEGAL_CONFIRM_TEXT:             'I confirm that all information provided for this contract is accurate and complete to the best of my knowledge. I understand that this information will be used to generate the final contract document, and that I am personally responsible for the submitted information and any consequences arising from inaccuracies.',

  // ── Signatures ─────────────────────────────────────────────────────────────
  CC_SIG_CARD_TITLE:          'Signatures',
  CC_SIG_FREELANCER_LABEL:    'On behalf of the freelancer:',
  CC_SIG_DATE_LABEL:          'Date',
  CC_SIG_PLACE_LABEL:         'Place',
  CC_SIG_SIGNATURE_LABEL:     'Signature',
  CC_SIG_DRAW_BTN:            'Draw Signature',
  CC_SIG_UPLOAD_BTN:          'Upload Signature',
  CC_SIG_CANVAS_HINT_DRAW:    'Draw your signature here',
  CC_SIG_CANVAS_HINT_UPLOAD:  'Your uploaded signature will appear here',
  CC_SIG_CLEAR_BTN:           'Clear',
  CC_SIG_NAME_LABEL:          'Name Clarification',
  CC_SIG_NAME_HINT:           'Enter your full name',
  CC_SIG_INVOZIO_LABEL:       'On behalf of Invozio LV SIA:',
  CC_SIG_INVOZIO_PRE_SIGNED:  'Digitally pre-signed',
  CC_SIG_CUSTOMER_LABEL:       'On behalf of the customer:',
  CC_SIG_CUSTOMER_PENDING_BADGE: 'Awaiting signature',
  CC_SIG_CUSTOMER_SIGNED_BADGE:  'Signed',
  CC_SIG_CUSTOMER_PENDING_BODY:  'The customer will sign after you send this agreement.',
  CC_SIG_CUSTOMER_PLACEHOLDER_NAME: 'Customer',

  // ── Footer actions ─────────────────────────────────────────────────────────
  CC_BTN_CANCEL:     'Cancel',
  CC_BTN_BACK:       'Back',
  CC_BTN_NEXT:       'Next',
  CC_BTN_SUBMIT:     'Submit',
  CC_BTN_SUBMITTING: 'Submitting…',
  CC_BTN_SAVE_DRAFT:     'Save as Draft',
  CC_BTN_SAVING_DRAFT:   'Saving…',
  CC_BTN_SEND_AGREEMENT: 'Send Agreement for Signature',
  CC_BTN_SENDING:        'Sending…',

  // ── Validation messages ────────────────────────────────────────────────────
  CC_VAL_FIELD_REQUIRED:      'This field is required.',
  CC_VAL_CUSTOMER_REQUIRED:   'Please select a customer.',
  CC_VAL_END_DATE_REQUIRED:   "Please set an end date or check 'No end date'.",
  CC_VAL_END_AFTER_START:     'End date must be after the start date.',
  CC_VAL_AMOUNT_POSITIVE:     'Please enter a valid amount greater than 0.',
  CC_VAL_TERMS_REQUIRED:      'Please accept the legal terms to continue.',
  CC_VAL_SIGNATURE_REQUIRED:  'Please provide a signature.',
  CC_VAL_ASSIGN_PERIOD_MAX:   'Assignment period cannot exceed 100 characters.',
  CC_VAL_OFFERED_SERVICES_MAX:'Offered services cannot exceed 500 characters.',

  // ── Toast messages ─────────────────────────────────────────────────────────
  CC_TOAST_CONFIRM_REQUIRED:  'Please confirm that all information is accurate.',
  CC_TOAST_CUSTOMER_REQUIRED: 'Please select a customer before submitting.',
  CC_TOAST_FILL_REQUIRED:     'Please fill in the required fields',
  CC_TOAST_SUCCESS:           'Contract created successfully!',
  CC_TOAST_ERROR:             'Failed to create contract. Please try again.',
  CC_TOAST_UPDATE_SUCCESS:    'Contract updated successfully!',
  CC_TOAST_UPDATE_ERROR:      'Failed to update contract. Please try again.',
  CC_TOAST_LOAD_ERROR:        'Failed to load the contract. Please try again.',
  CC_TOAST_SEND_SUCCESS:      'Contract saved and sent to the customer for signature!',
  CC_TOAST_SEND_ERROR:        'Failed to send the contract to the customer. Please try again.',
  CC_TOAST_SEND_LOOKUP_ERROR: 'Contract was saved, but it could not be sent automatically. Please send it from the contracts list.',

  // ── Send-agreement preview modal ───────────────────────────────────────────
  CC_PREVIEW_MODAL_TITLE: 'Review before sending',
  CC_PREVIEW_MODAL_SUBTITLE: 'Preview the agreement exactly as your customer will receive it.',
  CC_PREVIEW_SEND_TO:     'This agreement will be sent to {{name}} ({{email}}).',
  CC_PREVIEW_SWIPE_UP:    'Swipe up',
  CC_PREVIEW_SWIPE_DOWN:  'Swipe down',
  CC_PREVIEW_DOWNLOAD:    'Download PDF',
  CC_BTN_CONFIRM_SEND:    'Review and send to customer',

  // ── Edit mode ──────────────────────────────────────────────────────────────
  CC_PAGE_TITLE_EDIT: 'Edit Customer Agreement',
  CC_BTN_UPDATE:      'Update',
  CC_BTN_UPDATING:    'Updating…',
  CC_LOADING_CONTRACT: 'Loading agreement…',

  // ── Contracts grid ─────────────────────────────────────────────────────────
  CCG_TITLE:             'Your Agreements',
  CCG_LOADING:           'Loading agreements…',
  CCG_ERROR:             'Failed to load agreements. Please refresh.',
  CCG_EMPTY:             'No agreeements yet.',
  CCG_EMPTY_ARCHIVED:    'No archived agreements.',
  CCG_CREATE_FIRST:      'Create your first agreement',
  CCG_TAB_ALL:           'All',
  CCG_TAB_ARCHIVED:      'Archived',
  CCG_COL_CONTRACT_NO:   'Agreement No.',
  CCG_COL_CUSTOMER:      'Customer',
  CCG_COL_START_DATE:    'Start Date',
  CCG_ACTION_SEND:        'Send to customer',
  CCG_COL_END_DATE:      'End Date',
  CCG_COL_AMOUNT:        'Amount',
  CCG_COL_STATUS:        'Status',
  CCG_COL_CREATED:       'Created',
  CCG_NO_END_DATE:       'No end date',
  CCG_STATUS_DRAFT:      'Draft',
  CCG_STATUS_PENDING_SIGNATURE: 'Sent/Pending Signature',
  CCG_STATUS_ACTIVE:     'Signed/Active',
  CCG_STATUS_EXPIRED:    'Expired',
  CCG_STATUS_CANCELLED:  'Cancelled',
  CCG_STATUS_ARCHIVED:   'Archived',
  CCG_COL_ACTIONS:       'Actions',
  CCG_ACTION_DOWNLOAD_PDF: 'Download PDF',
  CCG_ACTION_EDIT:       'Edit Agreement',
  CCG_ACTION_EDIT_DISABLED: 'Only draft agreements can be edited',
  CCG_ACTION_EDIT_DISABLED_ARCHIVED: 'Archived agreements cannot be edited',
  CCG_DOWNLOAD_SUCCESS:  'PDF downloaded successfully.',
  CCG_DOWNLOAD_ERROR:    'Failed to download PDF. Please try again.',
  CCG_ACTION_SEND:           'Send to customer',
  CCG_ACTION_SEND_DISABLED_ARCHIVED: 'Archived agreements cannot be sent',
  CCG_ACTION_SEND_DISABLED_EXPIRED: 'Expired agreements cannot be sent. Duplicate it to create a new version.',
  CCG_ACTION_SEND_DISABLED_ACTIVE: 'This agreement is already active and cannot be sent again.',
  CCG_ACTION_SEND_DISABLED_CANCELLED: 'Cancelled contracts cannot be sent.',
  CCG_ACTION_DUPLICATE:      'Duplicate / Create new version',
  CCG_SEND_NO_EMAIL:         'This customer has no email address on file.',
  CCG_SEND_SUCCESS:          'Agreement emailed successfully.',
  CCG_SEND_ERROR:            'Failed to send the agreement email. Please try again.',
  CCG_ACTION_ARCHIVE:        'Archive agreement',
  CCG_ACTION_UNARCHIVE:      'Unarchive agreement',
  CCG_ARCHIVE_SUCCESS:       'Agreement archived successfully.',
  CCG_ARCHIVE_ERROR:         'Failed to archive the agreement. Please try again.',
  CCG_UNARCHIVE_SUCCESS:     'Agreement unarchived successfully.',
  CCG_UNARCHIVE_ERROR:       'Failed to unarchive the agreement. Please try again.',

  // ── Public customer contract sign/decline page ────────────────────────────
  CCSIGN_PAGE_TITLE:           'Customer Agreement',
  CCSIGN_PAGE_SUBTITLE:        'Please review the agreement below before accepting or declining it.',
  CCSIGN_LOADING:              'Loading agreement…',
  CCSIGN_LOAD_ERROR_TITLE:     'This link is no longer valid',
  CCSIGN_LOAD_ERROR_BODY:      "We couldn't load this agreement. The link may have expired, already been used, or is invalid.",
  CCSIGN_PDF_CARD_TITLE:       'Agreement Document',
  CCSIGN_BTN_ACCEPT:           'Accept & Sign',
  CCSIGN_BTN_DECLINE:          'Decline',
  CCSIGN_SIGN_CARD_TITLE:      'Confirm & Sign',
  CCSIGN_SIGNATURE_LABEL:      'Signature',
  CCSIGN_CANVAS_HINT:          'Draw your signature here',
  CCSIGN_CLEAR_BTN:            'Clear',
  CCSIGN_NAME_LABEL:           'Name Clarification',
  CCSIGN_NAME_HINT:            'Enter your full name',
  CCSIGN_TERMS_CONFIRM_TEXT:   'I have reviewed the agreement above and accept its terms and conditions.',
  CCSIGN_BTN_CONFIRM_SIGN:     'Confirm & Sign',
  CCSIGN_BTN_SIGNING:          'Signing…',
  CCSIGN_BTN_CANCEL:           'Cancel',
  CCSIGN_DECLINE_CARD_TITLE:   'Decline Agreement',
  CCSIGN_DECLINE_REASON_LABEL: 'Please tell us why you’re declining this agreement:',
  CCSIGN_DECLINE_REASON_HINT:  'Enter your reason...',
  CCSIGN_BTN_CONFIRM_DECLINE:  'Confirm Decline',
  CCSIGN_BTN_DECLINING:        'Declining…',
  CCSIGN_VAL_SIGNATURE_REQUIRED: 'Please provide a signature.',
  CCSIGN_VAL_NAME_REQUIRED:      'Please enter your full name.',
  CCSIGN_VAL_TERMS_REQUIRED:     'Please confirm that you accept the agreement.',
  CCSIGN_VAL_REASON_REQUIRED:    'Please provide a reason.',
  CCSIGN_SIGN_SUCCESS_TITLE:   'Agreement signed',
  CCSIGN_SIGN_SUCCESS_BODY:    'Thank you — the agreement has been signed successfully. You may now close this window.',
  CCSIGN_SIGN_ERROR:           'Failed to submit your signature. Please try again.',
  CCSIGN_BTN_DOWNLOAD:         'Download signed agreement',
  CCSIGN_BTN_DOWNLOADING:      'Downloading…',
  CCSIGN_DOWNLOAD_ERROR:       'Failed to download the signed agreement. Please try again.',
  CCSIGN_DECLINE_SUCCESS_TITLE: 'Agreement declined',
  CCSIGN_DECLINE_SUCCESS_BODY:  'You have declined this agreement. The sender has been notified.',
  CCSIGN_DECLINE_ERROR:         'Failed to submit your decline. Please try again.',
};
